
<app-aside-nav></app-aside-nav>
<div class="m-grid__item m-grid__item--fluid m-wrapper">
	<router-outlet *ngIf="!tinHandler.showOnDefault"></router-outlet>
	<div *ngIf="tinHandler.showOnDefault" class="h-100">
		<app-turn-it-in-launcher></app-turn-it-in-launcher>
	</div>
</div>